import React, { useMemo } from "react";
import { useCognitoAuth } from "frontend/src/components/CognitoAuth";
import { Auth, AuthContext, AuthProviderType } from "./AuthProvider.component";

/**
 * Adapter component that wraps the new CognitoAuthProvider
 * and provides the legacy Auth interface for compatibility with CustomAdmin
 */
export function CognitoAuthAdapter({ children }: { children: React.ReactNode }) {
  const { getIdToken, signOut, user, isAuthenticated } = useCognitoAuth();

  const auth: Auth | undefined = useMemo(
    () =>
      isAuthenticated && user
        ? {
            getIdToken: async () => {
              const token = await getIdToken();
              if (!token) throw new Error("No Cognito ID token available");
              return token;
            },
            signOut: async () => {
              await signOut();
            },
            authProvider: AuthProviderType.Cognito,
            getEmail: async () => {
              if (!user) throw new Error("No user available");
              return user.email || "";
            },
            refreshSession: () => {
              // Cognito provider handles auto-refresh via timer
            },
          }
        : undefined,
    [getIdToken, signOut, user, isAuthenticated]
  );

  return (
    <AuthContext.Provider
      value={{
        auth,
        configure: () => {},
        signOut: auth?.signOut || signOut,
        isLoading: false,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
